import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  styled,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import CommonLabel from "./label";
import theme from "../theme";
import { createApiCall } from "../api/api-service"

const StyeledCard = styled(Box)((theme) => ({
  minWidth: "10em",
  width: "10em",
  maxWidth: "192px",
  height: "300px",
  borderRadius: "10px",
  background: "#fff",
  textDecoration: "none",
}));

const GradientText = styled(Typography)(({ theme }) => ({
  background: `linear-gradient(60deg,${theme.palette.primary.main},${theme.palette.secondary.main})`,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontWeight: "bold",
}));

const DEFAULT_PRODUCT_IMAGE =
  "https://via.placeholder.com/300x300?text=No+Image";

const ProductCard = ({ product, defaultImage = DEFAULT_PRODUCT_IMAGE }) => {
  const track_user_clicked_product = async (variant_id,variant_price) =>{
    await createApiCall("POST","tracking/track-user-clicked-product",{"variant_id":variant_id,"variant_price":variant_price})
  }
  const [imgSrc, setImgSrc] = useState(product?.variant_image || defaultImage);

  return (
    
    // <Card component={'div'}
    // //   onClick={() => onClick?.(product)}
    //   sx={{
    //     display: "block",
    //     textAlign: "left",
    //     borderRadius: 0,
    //   }}
    // >
    //   <Box
    //     sx={{
    //       width: "100%",
    //       display: "flex",
    //       flexDirection: "column",
    //     }}
    //   >
    //     <Box
    //       sx={{
    //         width: "100%",
    //         overflow: "hidden",
    //         bgcolor: "#f7f7f7",
    //         mb: 1.25,
    //       }}
    //     >
    //       <Box
    //         component="img"
    //         src={imgSrc}
    //         alt={product?.variant_name || "Product"}
    //         onError={() => setImgSrc(defaultImage)}
    //         sx={{
    //           width: "100%",
    //           height: "100%",
    //           objectFit: "contain",
    //           display: "block",
    //         }}
    //       />
    //     </Box>

    //     <Typography
    //       sx={{
    //         fontSize: { xs: "13px", sm: "14px", md: "15px" },
    //         fontWeight: 400,
    //         color: "#111",
    //         lineHeight: 1.35,
    //         minHeight: { xs: 36, sm: 40, md: 44 },
    //         display: "-webkit-box",
    //         WebkitLineClamp: 2,
    //         WebkitBoxOrient: "vertical",
    //         overflow: "hidden",
    //         mb: 0.75,
    //       }}
    //     >
    //       {product?.variant_name}
    //     </Typography>

    //     <Typography
    //       sx={{
    //         fontSize: { xs: "11px", sm: "12px" },
    //         color: "#666",
    //         lineHeight: 1.2,
    //       }}
    //     >
    //       Starting from
    //     </Typography>

    //     <Typography
    //       sx={{
    //         fontSize: { xs: "16px", sm: "18px" },
    //         fontWeight: 500,
    //         color: "#ff4f87",
    //         lineHeight: 1.2,
    //         mt: 0.25,
    //       }}
    //     >
    //       {product?.price}
    //     </Typography>
    //   </Box>
    // </Card>

    <Link to={"/product/"+ product?.variant_url} style={{textDecoration:'none',color:'black'}} onClick={()=>{track_user_clicked_product(product?.variant_id,product?.variant_price)}}>

    <StyeledCard  >
    <CardMedia component={"img"} height={200} image={imgSrc} onError={() => setImgSrc(defaultImage)} alt={product?.variant_name} sx={{ objectFit: 'contain',minHeight:'13rem',maxHeight:'210px' }} />
    <Box sx={{display:'flex',flexDirection:'column',paddingLeft:'10px'}}>
       <CommonLabel variant="h6" sx={{letterSpacing:'0.5px'}} fontSize={'0.8rem'} fontWeight={"bold"} >{product?.variant_name.length >35? product?.variant_name.slice(0,35): product?.variant_name}</CommonLabel>
       <CommonLabel variant={'caption'} fontSize='0.75rem' sx={{color:theme.typography.colorGrey,letterSpacing:'0.5px'}} >Starting From <GradientText> {product?.variant_price} ₹</GradientText> </CommonLabel>
    </Box>
    

  </StyeledCard>
  </Link>
  );
};

export default ProductCard;
